import { restApi } from '../services/api';

export const uploadFiles = async (data: File[]) => {
  const formData = new FormData();
  data.forEach((d, index) => formData.append(`file_${index}`, d));
  return restApi.post<any>(`upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
